module.exports = __webpack_public_path__ + "img/pg3.69dbc806.png";